export function setAlert(content) {
    return (dispatch) => {
        dispatch({
            type: 'SET_ALERT',
            payload: content
        })
    }
}